export default __webpack_public_path__ + "static/media/about-2.cdf9bf40.png";